<template>
  <div v-show="isPropertyGroupPage" id="property_table">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- 物件モーダル -->
    <dd-property-modal
      ref="propertyModalRef"
      :clientPersonList="clientPersonList"
      :userAccountList="userAccountList"
      :estimateRemarkCodeList="estimateRemarkCodeList"
      @getPropertyList="getPropertyList"
    />
    <!-- 顧客担当者管理モーダル -->
    <dd-client-list-modal
      ref="clientListModalRef"
      :clientPersonList="clientPersonList"
      @getPropertyList="getPropertyList"
    />
    <!-- 見積オプションモーダル -->
    <dd-est-option-modal
      ref="estOptionModalRef"
      @getPropertyList="getPropertyList"
    />
    <!-- ステータス変更モーダル -->
    <dd-order-status-modal
      ref="orderStatusModalRef"
      :selectedProperty="selectedProperty"
      :orderStatusData="orderStatusData"
      @getPropertyList="getPropertyList"
    />
    <!-- 絞り込み検索モーダル -->
    <dd-property-search-modal
      ref="planSearchRef"
      :isDetailPage="isDetailPage"
      @onClickSearch="onClickSearch"
    />
    <!-- コンテキストメニュー -->
    <dd-plan-context-menu
      v-if="!isDetailPage"
      ref="contextMenuRef"
      :isDetailPage="isDetailPage"
      :isPropertyGroupPage="isPropertyGroupPage"
      :selectedPropertyPlanList="selectedPropertyPlanList"
      :selectedPropertyFileList="selectedPropertyFileList"
      @openEditModal="openEditModal"
      @openEstOptionModal="openEstOptionModal"
      @openOrderStatusModal="openOrderStatusModal"
      @openPreview="openPreview"
    />
    <div class="table_wrapper">
      <div>
        <dd-property-plan
          ref="propertyPlanRef"
          :isDetailPage="isDetailPage"
          :dispForm="dispForm"
          :defaultDispForm="defaultDispForm"
          @openEditModal="openEditModal"
          @openDispModal="openDispModal"
          @backMainPage="backMainPage"
        />
      </div>
      <div class="main_property_page" v-if="!isDetailPage">
        <!--  タイトルエリア  -->
        <div class="title_area">
          <h3 v-if="isPropertyGroupPage">物件管理 → 受注処理</h3>
        </div>
        <div class="form_area">
          <div class="button_area">
            <button class="main_btn register_btn" @click="openNewModal">物件新規登録</button>
            <button class="main_btn" @click="openClientListModal">顧客担当者管理</button>
            <button class="main_btn" @click="openSearchModal">絞り込み検索</button>
            <button class="main_btn" @click="downLoadCsv">CSV出力</button>
          </div>
          <!-- ページ -->
          <div>
            <dd-pager
              ref="pagerRef"
              :pageNo="pageNo"
              :dataCountPerPage="dataCount"
              :totalDataCount="totalCount"
              @paging="paging"
            />
          </div>
          <!-- 表示項目切り替え -->
          <div class="disp_btn" @click="openDispModal(false)">
            <div class="disp_icon">
              <span class="displogo"></span>
              <span class="displogo"></span>
              <span class="displogo"></span>
            </div>
            <div class="disptitle">表示項目</div>
          </div>
        </div>
        <!-- データテーブル -->
        <div class="property_list_area">
          <table>
            <thead>
              <tr>
                <th class="main_btn_th"></th>
                <th :class="{none: checkDisp(0)}">物件コード</th>
                <th :class="{none: checkDisp(1)}">物件名</th>
                <th :class="{none: checkDisp(2)}">物件住所</th>
                <th :class="{none: checkDisp(3)}">顧客会社名</th>
                <th :class="{none: checkDisp(4)}">顧客担当者名</th>
                <th :class="{none: checkDisp(5)}">見積依頼日</th>
                <th :class="{none: checkDisp(6)}">見積依頼番号</th>
                <th :class="{none: checkDisp(7)}">見積回答期日</th>
                <th :class="{none: checkDisp(8)}">受注ステータス</th>
                <th :class="{none: checkDisp(9)}">受注日</th>
                <th :class="{none: checkDisp(10)}">注文番号</th>
                <th :class="{none: checkDisp(11)}">担当者１</th>
                <th :class="{none: checkDisp(12)}">最終更新者</th>
              </tr>
            </thead>
            <tbody @mouseover="isOnListArea = true" @mouseout="isOnListArea = false" @contextmenu.prevent>
              <tr
                v-for="(property, index) in propertyDataList"
                :key="index"
                @mouseover="mouseover(property)"
                @mouseup="isPropertyMainPage && mouseup($event)"
                class="hover_color"
              >
                <td class="main_btn_td">
                  <button class="main_btn" style="min-width:80px; width:80px;" @click="showDetailPage(property)">詳細情報</button>
                </td>
                <td :class="{none: checkDisp(0)}">{{ property.cpropertyCd }}</td>
                <td :class="{none: checkDisp(1)}">{{ property.cpropertyName }}</td>
                <td :class="{none: checkDisp(2)}">{{ property.cpropertyAddress }}</td>
                <td :class="{none: checkDisp(3)}">{{ property.propertyClientName }}</td>
                <td :class="{none: checkDisp(4)}">{{ property.propertyClientPersonName }}</td>
                <td :class="{none: checkDisp(5)}">{{ getFormatDate(property.cpropertyEstAccountReqDate) }}</td>
                <td :class="{none: checkDisp(6)}">{{ property.cpropertyEstAccountReqNo }}</td>
                <td :class="{none: checkDisp(7)}">{{ getFormatDate(property.cpropertyEstAccountAnsDate) }}</td>
                <td :class="{none: checkDisp(8)}">{{ property.cpropertyOrderStatusLabel }}</td>
                <td :class="{none: checkDisp(9)}">{{ getFormatDate(property.cpropertyOrderDate) }}</td>
                <td :class="{none: checkDisp(10)}">{{ property.cpropertyOrderNo }}</td>
                <td :class="{none: checkDisp(11)}">{{ property.propertyPersonName1 }}</td>
                <td :class="{none: checkDisp(12)}">{{ property.updateUserName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Libraries
import axios from 'axios'
import moment from 'moment'
// Module
import {API_URL, MOUSE_BUTTON, STORAGE_KEY} from '../../constants/App'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import encoding from 'encoding-japanese'
import PropertyModal from '../list/modal/PropertyModal'
import PropertyPlanTable from '../list/PropertyPlanTable'
import ClientListModal from '../list/modal/ClientListModal'
import EstOptionModal from '../list/modal/EstOptionModal'
import OrderStatusModal from '../list/modal/OrderStatusModal'
import PlanContextMenu from '../list/PlanContextMenu.vue'
import PropertySearchModal from '../list/modal/PropertySearchModal'
import Pager from '../../components/common/OrderPager'
import LoadingModal from '../common/LoadingModal'

export default {
  name: 'PropertyTable',
  components: {
    'dd-property-modal': PropertyModal,
    'dd-property-plan': PropertyPlanTable,
    'dd-client-list-modal': ClientListModal,
    'dd-est-option-modal': EstOptionModal,
    'dd-order-status-modal': OrderStatusModal,
    'dd-plan-context-menu': PlanContextMenu,
    'dd-property-search-modal': PropertySearchModal,
    'dd-pager': Pager,
    'dd-loading-modal': LoadingModal
  },
  props: {
    isPropertyGroupPage: Boolean,
    dispForm: Object,
    defaultDispForm: Object
  },
  data () {
    return {
      /** ページ番号 */
      pageNo: 1,
      /** 1ページごとの表示件数 */
      dataCount: 14,
      /** 総件数 */
      totalCount: 0,
      /** 物件情報 */
      propertyDataList: [],
      /** 顧客担当者リスト */
      clientPersonList: [],
      /** 担当者(ユーザー)リスト */
      userAccountList: [],
      /** 見積書備考用コードリスト */
      estimateRemarkCodeList: [],
      /** 選択中物件 */
      selectedProperty: null,
      /** 選択中物件のルームプランリスト */
      selectedPropertyPlanList: [],
      /** 選択中物件のファイルデータリスト */
      selectedPropertyFileList: [],
      /** 物件詳細情報表示フラグ */
      isDetailPage: false,
      /** リスト上フラグ */
      isOnListArea: false,
      /** 受注ステータス */
      orderStatusData: [
        {label: '未受注', code: 0},
        {label: '受注確定', code: 5},
        {label: '受注処理済', code: 10}
      ],
      searchForm: {
        propertyCd: '',
        propertyName: '',
        clientName: '',
        clientPersonName: '',
        estAccountReqDateStart: '',
        estAccountReqDateEnd: '',
        estAccountReqNo: '',
        orderStatus: [],
        propertyOrderDateStart: '',
        propertyOrderDateEnd: '',
        accountOrderNo: '',
        personName1: '',
        propertyId: '',
        propertyBuildingName: '',
        propertyFloorName: '',
        propertyRoomName: '',
        fileCode: '',
        fileName: '',
        businessName: '',
        propertyArrivalDateStart: '',
        propertyArrivalDateEnd: '',
        pageNo: '',
        dataCount: ''
      },
      defaultDispStatus: [0, 5, 10]
    }
  },
  created: function () {
  },
  computed: {
    /** 物件一覧ページ表示フラグ */
    isPropertyMainPage: function () {
      return this.isPropertyGroupPage && !this.isDetailPage
    }
  },
  methods: {
    /** 物件管理リストを取得・表示 */
    getPropertyList: function (isFirstView) {
      this.isDetailPage = false
      if (isFirstView) {
        this.pageNo = 1
        this.$refs.pagerRef.setCurrentPage(this.pageNo)
        this.clear()
      } else {
        this.searchForm = App.getLocalStorage(STORAGE_KEY.PROPERTY_SEARCH)
      }
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.onSearch(this.searchForm)
    },
    /** 物件新規モーダルを開く */
    openNewModal: function () {
      this.$refs.propertyModalRef.showNewModal()
    },
    /** 物件編集モーダルを開く */
    openEditModal: function (data) {
      this.$refs.propertyModalRef.showEditModal(data)
    },
    /** 物件詳細ページを開く */
    showDetailPage: function (data) {
      this.isDetailPage = true
      this.$refs.propertyPlanRef.showDetailPage(data)
    },
    /** 担当者管理モーダルを開く */
    openClientListModal: function () {
      this.$refs.clientListModalRef.showNewModal()
    },
    /** 見積オプションモーダルを開く */
    openEstOptionModal: function (data) {
      this.$refs.estOptionModalRef.showModal(data)
    },
    /** 受注ステータスモーダルを開く */
    openOrderStatusModal: function (data) {
      this.$refs.orderStatusModalRef.showModal(data)
    },
    /** 絞り込み条件設定モーダルを開く */
    openSearchModal: function () {
      this.$refs.planSearchRef.showModal()
    },
    /** 表示項目切替モーダルを開く */
    openDispModal: function (detailFlg) {
      this.$emit('showPropertyDispModal', detailFlg)
    },
    /** プレビュー表示 */
    openPreview: function () {
      let childWindow = window.open('/#/property_preview?propertyId=' + this.selectedProperty.cpropertyId, 'preview-page', 'width=1200, height=900')
      childWindow.location.reload()
    },
    /** メインページへ戻る */
    backMainPage: function () {
      this.getPropertyList()
    },
    /** 検索ボタン押下 */
    onClickSearch: function (searchForm) {
      this.pageNo = 1
      this.$refs.pagerRef.setCurrentPage(this.pageNo)
      searchForm.pageNo = this.pageNo
      searchForm.dataCount = this.dataCount
      this.onSearch(searchForm)
    },
    /** 物件情報一覧取得 */
    onSearch: function (searchForm) {
      App.setLocalStorage(STORAGE_KEY.PROPERTY_SEARCH, searchForm)
      this.$refs.loadingModalRef.showModal(true)
      if (searchForm.orderStatus.length === 0) {
        searchForm.orderStatus = this.defaultDispStatus
      }
      axios.post(API_URL.PROPERTY + '/list', searchForm)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.propertyDataList = response.data.data.propertyList
          this.totalCount = response.data.data.propertyCount
          this.clientPersonList = response.data.data.clientPersonList
          this.userAccountList = response.data.data.userAccountList
          this.estimateRemarkCodeList = response.data.data.estimateRemarkCodeList
          // 担当者情報の設定
          this.propertyDataList
            .forEach(property => {
              if (!property.mcorpClientPerson || !property.mcorpClientPerson.ccorpClientName) {
              // 顧客担当者マスターの有効データに該当するものがない場合は、顧客担当者は削除済とする
                property.propertyClientName = '（削除済）'
                property.propertyClientPersonName = '（削除済）'
              } else {
                property.propertyClientName = property.mcorpClientPerson.ccorpClientName
                property.propertyClientPersonName = property.mcorpClientPerson.ccorpClientPersonName
              }
              if (property.cpropertyPersonId1) {
              // 担当者1にIDが指定されているが、ユーザーアカウントの有効データに該当するものがない場合は、担当者は削除済とする
                property.propertyPersonName1 = property.suserAccount ? property.suserAccount.fullName : '（削除済）'
              } else {
                property.propertyPersonName1 = ''
              }
              property.cpropertyOrderStatusLabel = this.orderStatusData.find(status => status.code === property.cpropertyOrderStatus).label
              let updateUser = this.userAccountList.find(user => user.cuserId === property.cupdateUserId)
              if (updateUser) property.updateUserName = updateUser.fullName
            })
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error)
        })
    },
    /** 物件のルームプランを取得する */
    getPropertyPlanList: function (data) {
      axios.get(API_URL.PROPERTY + '/plan/list/' + data.cpropertyId
      ).then(response => {
        this.selectedPropertyPlanList = response.data.data.roomPlanList
        this.selectedPropertyFileList = response.data.data.fileDataList
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 項目の表示・非表示判定 */
    checkDisp: function (num) {
      return !this.dispForm.propertyCheckList.includes(num)
    },
    /** 数字ボタンが押すたびに動く処理 */
    paging: function (pageNo) {
      this.pageNo = pageNo
      this.searchForm = App.getLocalStorage(STORAGE_KEY.PROPERTY_SEARCH)
      this.searchForm.pageNo = this.pageNo
      this.searchForm.dataCount = this.dataCount
      this.getPropertyList()
    },
    /** CSV出力 */
    downLoadCsv: function () {
      axios.get(API_URL.PROPERTY + '/download')
        .then(response => {
          let formatStr = moment().format('YYYYMMDDHHmmss')
          let arrayData = response.data.data
          let csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          // SJISに変換する
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PropertyList_' + formatStr + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clear: function () {
      this.searchForm = {
        propertyCd: '',
        propertyName: '',
        clientName: '',
        clientPersonName: '',
        estAccountReqDateStart: '',
        estAccountReqDateEnd: '',
        estAccountReqNo: '',
        orderStatus: [],
        propertyOrderDateStart: '',
        propertyOrderDateEnd: '',
        accountOrderNo: '',
        personName1: '',
        propertyId: '',
        propertyBuildingName: '',
        propertyFloorName: '',
        propertyRoomName: '',
        fileCode: '',
        fileName: '',
        businessName: '',
        propertyArrivalDateStart: '',
        propertyArrivalDateEnd: '',
        pageNo: '',
        dataCount: ''
      }
    },
    /** マウスアップ */
    mouseup: function (event) {
      if (this.isPropertyMainPage) {
        if (this.isOnListArea && event.button === MOUSE_BUTTON.RIGHT) {
          this.getPropertyPlanList(this.selectedProperty)
          this.$refs.contextMenuRef.show({ x: event.pageX, y: event.pageY }, this.selectedProperty)
        } else {
          this.$refs.contextMenuRef.close()
        }
      }
    },
    mouseover: function (data) {
      this.selectedProperty = data
    },
    getFormatDate: function (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD')
      } else {
        return ''
      }
    }
  }
}
</script>

<style src="../../css/list/list.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#property_table {
  height: 95%;
  width: 95%;
  padding: 10px 30px;
}
.title_area {
  padding: 10px 0;
  text-align: center;
  width: 260px;
  color: #4472C4;
  background-color: #FEF2CB;
  h3 {
    font-size: 1.5em;
    display: inline-block;
  }
}
.form_area{
  margin: 10px;
  display: flex;
  justify-content: flex-start;
  height: 38px;
  .button_area {
    margin: 5px 0px 10px 0px;
  }
}
.table_wrapper {
  height: 100%;
  width: 100%;
}
.main_property_page {
  height: 100%;
}
.roomplan_page {
  height: 100%;
}
.property_list_area {
  height: 90%;
  overflow-y: auto;
}
.main_btn_th {
  width:95px;
  padding: 4px 0px 0px;
}
.main_btn_td {
  width:95px;
  padding:2px 0px
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/PropertyTable.vue